import { AbstractControl, FormControl, FormGroup, ValidatorFn } from "@angular/forms"

export const resetControl = (control: AbstractControl, clearValidators = true): void => {
    control.setValue('');
    clearValidators && control.clearValidators();
    control.updateValueAndValidity();
}

export const setControlsValidators = (
    group: FormGroup,
    controls: string[],
    validators: ValidatorFn[]
) => {
    const keys = Object.keys(group.controls);
    if (keys.length > 0) {
        controls.forEach(control => {
            const ctrlObj = group.controls[control];
            if (ctrlObj) {
                ctrlObj.addValidators([...validators]);
                ctrlObj.updateValueAndValidity();
            }
        })
    }
}

export const februaryDays = (anio: number): number => {
    const isBisiest = (anio % 4 === 0 && anio % 100 !== 0) || (anio % 400 === 0);
    return isBisiest ? 29 : 28;
}

export const lastMonthDay = (year: number, month: number, defaultDay = 30) => {
    const day = month === 1 ? februaryDays(year) : defaultDay;
    return day;
}

export const disableControl = (control: AbstractControl, defValue = '') => {
    control.setValue(defValue);
    control.disable();
}

export const enableControl = (control: AbstractControl, defValue = '') => {
    control.setValue(defValue);
    control.enable();
}